import { Button, SubmitButton, toast } from "@bleu.builders/ui";
import React from "react";
import { useWizard } from "react-use-wizard";

import { cn } from "#/lib/utils";

export const Step = ({
  children,
  form,
  onNext = () => {},
  onPrevious = () => {},
  handleSubmit,
  mode,
}) => {
  const { nextStep, previousStep, isFirstStep, isLastStep } = useWizard();

  const handleNext = async () => {
    const isValid = await form.trigger();
    if (!isValid) {
      toast({
        title: "Erro",
        description: "Por favor, preencha todos os campos obrigatórios.",
        variant: "destructive",
      });

      return;
    }
    onNext();
    nextStep();
  };

  const handlePrevious = () => {
    onPrevious();
    previousStep();
  };

  return (
    <div className="flex flex-col">
      <div className="">{children}</div>
      <div className="mt-auto flex justify-end space-x-2">
        <div className="m-2 flex gap-3">
          <Button
            variant="outline"
            type="button"
            onClick={() => handlePrevious()}
            disabled={isFirstStep}
          >
            Anterior
          </Button>

          {isLastStep ? (
            <SubmitButton type="button" onClick={handleSubmit}>
              Salvar
            </SubmitButton>
          ) : (
            <div className="flex gap-2">
              <Button
                type="button"
                onClick={() => handleNext()}
                disabled={isLastStep}
                className="ml-auto"
              >
                Próximo
              </Button>
              <SubmitButton
                type="button"
                onClick={handleSubmit}
                variant="secondary"
                className={cn({ hidden: mode !== "update" })}
              >
                Salvar
              </SubmitButton>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
